<template>
	<div>
		<div v-if="isUserAllowedInLevel2">
			<BaseHeader :title="companyType.title" />
			<div class="main">
				<BaseSelect v-model="filter" :options="filterOptions" class="w-56" label="Filter" />

				<div v-if="companies && companies.length">
					<div class="flex flex-col">
						<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
							<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
								<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
									<table class="min-w-full divide-y divide-gray-200">
										<thead>
											<tr>
												<th
													v-for="header in getHeader"
													:key="header.name"
													:class="header.class"
													class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												>
													{{ header.name }}
												</th>
											</tr>
										</thead>
										<tbody class="bg-white divide-y divide-gray-200">
											<DamageAssessorCompanyRow
												class="cursor-pointer"
												v-for="company in getCompanies"
												:key="company.id"
												:company-type="companyType"
												:value="company"
											/>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else-if="!companies" class="flex flex-grow justify-center w-full opacity-75">
					<loader color="#343434" />
				</div>
				<div v-else>{{ $t('no_entries_found') }}</div>
			</div>
		</div>
		<div v-else>
			<Forbidden />
		</div>
	</div>
</template>

<script>
import loader from 'vue-spinner/src/PulseLoader.vue';
import BaseHeader from '@/components/navigation/BaseHeader';
import { RepairshopsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import Forbidden from '@/views/default/Forbidden';
import Authentication from '@/mixins/Authentication';
import DamageAssessorCompanyRow from '@/components/rows/DamageAssesorCompanyRow';

export default {
	name: 'IndexCompanies',
	components: { DamageAssessorCompanyRow, Forbidden, BaseSelect, BaseHeader, loader },
	mixins: [Authentication],
	data() {
		return {
			companyType: {
				title: this.$t('companies'),
				buttonText: this.$t('company'),
			},
			companies: null,
			filterOptions: [
				{
					display: this.$t('enabled'),
					value: 'enabled',
				},
				{
					display: this.$t('disabled'),
					value: 'disabled',
				},
				{
					display: this.$t('all'),
					value: 'all',
				},
			],
			filter: {
				display: this.$t('enabled'),
				value: 'enabled',
			},
		};
	},
	created() {
		if (this.isUserAllowedInLevel2) {
			this.updateCompanies();
			this.setCompanyType();
		}
	},
	methods: {
		updateCompanies() {
			let promise;

			switch (this.$route.params.type) {
				case 'repairShop':
					promise = RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).repairshopsGet(
						0,
						1,
						undefined,
						undefined,
						this.getUserCompany.companyable.id,
					);
					break;
				case 'car_dealership':
					promise = RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).repairshopsGet(
						1,
						1,
						undefined,
						undefined,
						this.getUserCompany.companyable.id,
					);
					break;
			}

			promise?.then(response => {
				this.companies = response.data?.data || response.data;
			});
		},
		setCompanyType() {
			switch (this.$route.params.type) {
				case 'repairShop':
					this.companyType.title = this.$t('repair_shops');
					this.companyType.buttonText = this.$t('repair_shop');
					break;
				case 'car_dealership':
					this.companyType.title = this.$t('car_shops');
					this.companyType.buttonText = this.$t('car_shop');
					break;
			}
		},
	},
	computed: {
		getEnabledCompanies() {
			return this.companies.filter(company => company.is_enabled);
		},
		getDisabledCompanies() {
			return this.companies.filter(company => !company.is_enabled);
		},
		getCompanies() {
			let companies;
			switch (this.filter.value) {
				case 'enabled':
					companies = this.getEnabledCompanies;
					break;
				case 'disabled':
					companies = this.getDisabledCompanies;
					break;
				default:
					companies = this.companies;
					break;
			}

			return companies;
		},
		getHeader() {
			const header = [];
			header.push({ name: this.$t('name'), class: 'px-6' });
			header.push({ name: this.$t('company_registration_number'), class: 'px-6' });
			header.push({ name: this.$t('address'), class: 'px-6' });
			return header;
		},
	},
	watch: {
		'$route.params.type'() {
			this.companies = null;
			this.updateCompanies();
			this.setCompanyType();
		},
	},
};
</script>
